function normalizeItemStatus(value) {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function isItemStatusSoldOut(value) {
  const status = normalizeItemStatus(value);
  return status !== null ? status !== 0 : false;
}

function extractItemStatusFromItemApiResponse(responseData) {
  const itemData = responseData?.itemData || {};
  const data = itemData?.data || itemData?.itemData?.data || {};

  return normalizeItemStatus(
    itemData?.itemStatus ??
    data?.itemStatus ??
    data?.itemDO?.itemStatus ??
    responseData?.itemStatus
  );
}

function buildItemStatusKey(item, extractProductId, extractCategoryId) {
  const productId = item?.productId || (typeof extractProductId === 'function' ? extractProductId(item?.url || '') : '');
  if (!productId) return '';

  const categoryId = item?.categoryId || (typeof extractCategoryId === 'function' ? extractCategoryId(item?.url || '') : '') || '0';
  return `${productId}:${categoryId}`;
}

function isCartItemSoldOut(item, itemStatusByKey, extractProductId, extractCategoryId) {
  if (isItemStatusSoldOut(item?.itemStatus)) return true;
  if (normalizeItemStatus(item?.itemStatus) === 0) return false;

  const key = buildItemStatusKey(item, extractProductId, extractCategoryId);
  if (!key) return false;

  return isItemStatusSoldOut(itemStatusByKey?.[key]);
}

const itemStatusUtils = {
  normalizeItemStatus,
  isItemStatusSoldOut,
  extractItemStatusFromItemApiResponse,
  buildItemStatusKey,
  isCartItemSoldOut,
};

module.exports = itemStatusUtils;
module.exports.default = itemStatusUtils;